import { MiAutocomplete } from "@miplatform/components";
import { ISSUE_AREAS_OPTIONS } from "@miplatform/constants";

export function AreaAutoComplete({ onChange, ...props }) {
  return (
    <MiAutocomplete
      fullWidth
      freeSolo
      size="small"
      options={ISSUE_AREAS_OPTIONS.map((o) => o.label)}
      onChange={(_, option) => {
        onChange(option);
      }}
      onInputChange={(_, inputValue) => {
        onChange(inputValue);
      }}
      {...props}
    />
  );
}
